import * as R from 'ramda';

import { Media } from '@atom/types/media';
import { Task, TaskField } from '@atom/types/task';
import { WorkOrderDetailType } from '@atom/types/work';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import { setDisplayDate } from '@atom/utilities/timeUtilities';
import { getWorkOrderStatusType } from '@atom/utilities/workOrderStatusUtilities';

import classes from './scdotPdfReport.module.css';

interface Props {
  workOrder: WorkOrderDetailType;
  task: Task;
  media: Media[];
}

const CoverSection = ({ workOrder, task, media }: Props) => {
  const coverPhoto = R.find(
    (item: Media) => item.id === workOrder?.mainPhotoId,
    media,
  );
  const inspectionDate = R.find(
    (field: TaskField) => field.title === 'Inspection Date',
    task?.fields || [],
  );
  const teamLeader = R.find(
    (field: TaskField) => field.title === 'Team Leader',
    task?.fields || [],
  );
  const teamMember = R.find(
    (field: TaskField) => field.title === 'Team Member',
    task?.fields || [],
  );

  return (
    <div className={classes.coverSection}>
      <div className={classes.generalDataSection}>
        <div className={classes.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>General Data</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Work:</td>
                <td>{workOrder?.workTemplateName || '-'}</td>
              </tr>
              <tr>
                <td>Work Status:</td>
                <td>
                  {getWorkOrderStatusType(workOrder?.statusId)?.label || '-'}
                </td>
              </tr>
              <tr>
                <td>Inspection Date:</td>
                <td>{setDisplayDate(inspectionDate?.value)}</td>
              </tr>
              <tr>
                <td>Team Leader:</td>
                <td>{teamLeader?.value || '-'}</td>
              </tr>
              <tr>
                <td>Team Member:</td>
                <td>{teamMember?.value || '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={classes.coverPhotoSection}>
        <div
          style={{
            backgroundImage: `url('${FILES_ENDPOINT}/${coverPhoto?.fileId}_1440')`,
          }}
          className={classes.mainPhotoContainer}
        />
      </div>
    </div>
  );
};

export default CoverSection;
